module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"16\" height=\"11\" viewBox=\"0 0 16 11\"><defs><path id=\"orqka\" d=\"M21.9 1234l-5.9-5.9 1.4-1.4 4.5 4.4 8.1-8.1 1.4 1.4z\"/></defs><g><g transform=\"translate(-16 -1223)\"><use fill=\"#5d5d5d\" xlink:href=\"#orqka\"/></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/checkbox.svg
// module id = 464
// module chunks = 0